import {
  OrientationEnum,
  OrientationType
} from "../../../interactions/OrderInteraction/types"
import { useDroppable } from "@dnd-kit/core"
import { Box, styled } from "@mui/material"
import { FC, useEffect, useRef, useState } from "react"

interface BlockDropContainerComponentProps {
  id: string
  orientation?: OrientationType
  children?: JSX.Element | JSX.Element[]
}

export const BlockDropContainerComponent: FC<
  BlockDropContainerComponentProps
> = props => {
  const {
    id,
    orientation = OrientationEnum.vertical,
    children,
    ...rest
  } = props
  const containerRef = useRef(null)
  const { setNodeRef } = useDroppable({ id })
  const [minContainerHeight, setMinContainerHeight] = useState(185)

  setNodeRef(containerRef.current)

  useEffect(() => {
    const { offsetHeight = 0 } = containerRef?.current || {}
    setMinContainerHeight(prevValue =>
      prevValue > offsetHeight ? prevValue : offsetHeight
    )
  }, [containerRef?.current?.offsetHeight])

  return (
    <StyledBlockDropContainer
      ref={containerRef}
      orientation={orientation}
      minHeight={minContainerHeight}
      {...rest}
    >
      {children}
    </StyledBlockDropContainer>
  )
}

interface StyledBlockDropContainerProps {
  orientation: OrientationType
  minHeight?: number
}

const StyledBlockDropContainer = styled(Box)<StyledBlockDropContainerProps>(
  ({ theme, orientation, minHeight }) => ({
    minHeight: orientation === OrientationEnum.vertical ? minHeight : "55px",
    padding: theme.spacing(2),
    border: `2px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.shape.borderRadius,
    overflow: "scroll",
    ...(orientation === OrientationEnum.vertical
      ? {
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minWidth: "max(240px, 40%)"
        }
      : {
          display: "flex",
          gap: theme.spacing(2),
          flexWrap: "wrap",
          "& > div": {
            margin: 0,
            "&:not(:last-child)": {
              margin: 0
            },
            "& > span": {
              minWidth: "fit-content"
            }
          },

          [theme.breakpoints.down("mobile")]: {
            columnGap: theme.spacing(1),
            rowGap: theme.spacing(2)
          }
        })
  })
)
